<template>
  <div>
    <div v-show="saved">
      <AnimatedCheckMark :done="saved"/>
      <p class="aligncenter">Votre rendez-vous est enregistré. Vous pouvez déposer votre véhicule dès l'ouverture de
        l'atelier.<br><b>{{ creneau }}</b>
      </p>
    </div>
    <div class="retrait" v-if="!saved">
      <div v-if="loadingServerData">
        <SkeletonDiv v-for="i in 9" :key="i" :height="35" style="margin-bottom: 1rem"/>
      </div>
      <form v-else ref="form">
        <fieldset>
          <legend>{{ serverData.rdv }} :</legend>
          <div class="grid__label-input">
            <label for="atelier">Type de RDV</label>
            <select id="atelier" v-model="atelier">
              <option value="26427">Révision 3 mois</option>
              <option value="12705">Révision 1 an</option>
              <option value="12704">Révision 2 ans</option>
              <option value="4834">Révision 3 ans</option>
              <option value="37660">Révision 4 ans</option>
              <option value="reparation">Réparation</option>
            </select>
          </div>
          <div v-if="atelier === 'reparation'">
            <p class="delai">Pour les réparations merci de prendre rendez-vous par téléphone au 09 74 59 58 10.</p>
          </div>
          <div class="grid__label-input" v-if="stockLines && stockLines.length > 0">
            <label for="bike">Véhicule</label>
            <select id="bike" v-model.number="stockLineId" required>
              <option value="">Sélectionnez l'immatriculation</option>
              <option v-for="line in stockLines" :value="line.id">{{ line.immat }}</option>
            </select>
          </div>
          <div class="grid__label-input">
            <label for="prenom">Prénom</label>
            <input type="text" id="prenom" v-model="first_name" placeholder="Prénom..." required>
          </div>
          <div class="grid__label-input">
            <label for="nom">Nom</label>
            <input id="nom" type="text" v-model="last_name" placeholder="Nom..." required>
          </div>
          <div class="grid__label-input">
            <label for="email">Email</label>
            <input id="email" type="email" v-model="user_email" placeholder="Votre email..." required>
          </div>
          <div class="grid__label-input">
            <label for="phone">Téléphone</label>
            <input id="phone" type="text" v-model="billing_phone" placeholder="Votre téléphone..." maxlength="10"
                   pattern="^(?:0|\(?\+33\)?\s?|0033\s?)[1-79](?:[\.\-\s]?\d\d){4}$" required>
          </div>
          <div class="retrait__form--helper" v-show="atelier !== 'reparation'">
            Cliquez sur un créneau disponible dans le calendrier
            <em>(changer de mécanicien pour accéder à plus de disponibilités) &#x2192;</em></div>
        </fieldset>
      </form>
      <SvgSpinner v-if="!calCanMount"/>
      <div v-if="calCanMount" v-show="atelier !== 'reparation'">
        <VueCal class="vuecal--blue-theme" :hide-weekdays="[7]"
                :time-from="timeFrom" :time-to="19 * 60" :time-step="60"
                locale="fr" :disable-views="['years', 'year', 'month']"
                :selectedDate="selectedDate" :minDate="minDate"
                :events="events" v-on:view-change="viewChange"
                :on-event-click="eventClick" v-on:ready="viewChange">
          <template #title="{ title }">{{ title }}</template>
          <template v-slot:no-event>
            <template v-if="loading">Chargement...</template>
          </template>
        </VueCal>
        <div class="retrait__vuecal--overlay"></div>
      </div>
      <Modal>
        <transition name="fade" mode="out-in">
          <SvgSpinner :key="1" v-if="saving && !saved"/>
          <div :key="2" v-if="!saving && !saved">
            <p>Veuillez confirmer le rendez-vous :</p>
            <ul>
              <li>
                <h4>{{ creneau }}</h4>
              </li>
            </ul>
            <hr>
            <footer>
              <button class="button" @click="$store.dispatch('closeModal')">ANNULER</button>
              <button class="button" @click="save" ref="save">CONFIRMER</button>
            </footer>
          </div>
        </transition>
      </Modal>
    </div>
  </div>
</template>

<script>
import VueCal from 'vue-cal'
import 'vue-cal/dist/i18n/fr'
import 'vue-cal/dist/vuecal.css'
import Modal from "@/components/partials/Modal";
import SvgSpinner from "@/components/partials/SvgSpinner";
import AnimatedCheckMark from "@/components/partials/AnimatedCheckMark";
import SkeletonDiv from "@/components/skeletons/SkeletonDiv.vue";
import InputRadio from "@/front/components/partials/InputRadio.vue";
import Calendar from "@/components/icons/Calendar.vue";
import {startOfHour, addHours, addMinutes} from 'date-fns'

export default {
  name: "RdvAtelier",
  components: {AnimatedCheckMark, SvgSpinner, Modal, VueCal, SkeletonDiv, InputRadio, Calendar},
  data() {
    return {
      start: 0,
      loading: false,
      loadingServerData: false,
      saving: false,
      saved: false,
      creneau: '',
      creneauxDispo: [],
      serverData: {},
      vueCalCurrentView: {}, // store the vue-cal current view data
      calCanMount: false,
      first_name: '',
      last_name: '',
      user_email: '',
      billing_phone: '',
      stockLines: [],
      intervalId: 0,
      stockLineId: '',
      atelier: '26427',
      detail: '',
      duration: 3600,
      postId: '',
    }
  },
  computed: {
    calendarId() {
      return this.serverData.calendar_id
    },
    timeFrom() {
      return 8 * 60
    },
    /**
     * Set the date on which the calendar will do its first load, for example if today is thursday then load the calendar on Monday next week, otherwise customer sees a blank calendar as there is at least a one day gap.
     */
    selectedDate() {
      let today = new Date()
      if (today.getDay() === 6 || today.getDay() === 0) {
        today = today.addDays(8 - today.getDay())
      }
      return today
    },
    minDate() {
      let now = new Date()
      const add = now.getDay() === 6 ? 2 : 1;
      return now.addDays(add)
    },
    /**
     * The available slots being displayed in the vue-cal component
     */
    events() {
      return this.creneauxDispo.map(creneau => {
        return {
          start: `${creneau.substring(0, 16)}`, // '2019-07-20 09:00',
          end: `${creneau.substring(0, 10)} ${creneau.substring(19)}`,
          title: 'Créneau disponible',
          class: '',
          content: ''
        }
      })
    },
  },
  methods: {
    creneauxSemaine() {
      return [
        '10:00 - 10:30',
        '10:30 - 11:00',
        '11:00 - 11:30',
        '11:30 - 12:00',
        '12:00 - 12:30',
        '12:30 - 13:00',
        '14:00 - 14:30',
        '14:30 - 15:00',
        '15:00 - 15:30',
        '15:30 - 16:00',
        '16:00 - 16:30',
        '16:30 - 17:00',
        '17:00 - 17:30',
        '17:30 - 18:00',
      ];
    },
    massageMinutes(value) {
      return value === 0 ? '00' : value;
    },
    massageHours(value) {
      return value < 10 ? `0${value}` : value;
    },
    range(n) {
      return [...Array(Math.ceil(n)).keys()]
    },
    viewChange(payload) {
      if (this.intervalId > 0) {
        clearInterval(this.intervalId);
      }
      this.vueCalCurrentView = payload
      this.reset();
      this.gapiCheckWeek(payload)
      // Reload automatically every 30 seconds to avoid duplicate in slots
      this.intervalId = setInterval(this.reload, 30000)
    },
    reload() {
      this.reset();
      this.gapiCheckWeek(this.vueCalCurrentView)
    },
    reset() {
      this.creneauxDispo = []
    },
    eventClick(vueCalEvent) {
      if (this.$refs.form.checkValidity()) {
        this.start = vueCalEvent.start.format('YYYY-MM-DD HH:mm');
        this.duration = (vueCalEvent.end.getTime() - vueCalEvent.start.getTime()) / 1000 // duration for the server script
        this.creneau = `${vueCalEvent.start.format(`dddd DD MMMM YYYY`)} de ${vueCalEvent.start.format(`HH:mm`)} à ${vueCalEvent.end.format(`HH:mm`)}`
        this.$store.dispatch('openModal')
      } else {
        this.$refs.form.reportValidity()
      }
    },
    gapiCheckWeek(payload) {
      let now = new Date()
      let min = payload.startDate
      // console.log(min.toISOString())
      if (payload.startDate.getTime() < now.getTime()) {
        const add = now.getDay() === 6 ? 2 : 1;
        min = now.addDays(add)
        min.setHours(8) // Important ! otherwise only the events after the current time are returned and this displays available slots when they're not (hence double entries)
      }
      // console.log(min.format())
      const vm = this;
      this.loading = true
      $api.post(`g2r/v1/calendar/event/list`, {
        calendarId: vm.calendarId,
        timeMin: min.toISOString(),
        timeMax: payload.endDate.toISOString(),
        showDeleted: false,
        singleEvents: true,
        maxResults: 80,
        orderBy: 'startTime',
      })
        .then(response => response.data)
        .then(data => { // data is events array
          this.reset()
          let creneauxPris = new Set() // taken slots in calendar
          const days = new Set() // days which have an existing event in calendar
          let dayOfTheWeek = new Date(min)
          while (dayOfTheWeek.getTime() < payload.endDate.getTime()) {
            days.add(dayOfTheWeek.format())
            dayOfTheWeek = dayOfTheWeek.addDays(1)
          }
          const blockedDays = new Set() // days blocked in calendar
          data.forEach(event => {
            if (null !== event.start.dateTime && null !== event.end.dateTime) {
              let start = new Date(event.start.dateTime);
              let end = new Date(event.end.dateTime);
              // If start minutes is between 31 and 59 then round it to the next hour
              if (start.getMinutes() > 30 && start.getMinutes() < 60) {
                start = addHours(startOfHour(start), 1);
              }
              if (end.getMinutes() > 30 && end.getMinutes() < 60) {
                end = addHours(startOfHour(end), 1);
              }
              if (start.getMinutes() > 1 && start.getMinutes() < 30) {
                start = addMinutes(startOfHour(start), 30);
              }
              if (end.getMinutes() > 1 && end.getMinutes() < 30) {
                end = addMinutes(startOfHour(end), 30);
              }
              const duration = (end - start) / 1000;
              vm.range(duration / 1800).forEach(() => {
                let string = `${start.format()} ${vm.massageHours(start.getHours())}:${vm.massageMinutes(start.getMinutes())}`;
                start = new Date(start.setTime(start.getTime() + (1800 * 1000)));
                string = `${string} - ${vm.massageHours(start.getHours())}:${vm.massageMinutes(start.getMinutes())}`;
                creneauxPris.add(string)
              })
            } else {
              blockedDays.add(new Date(event.start.date).getDay())
            }
          }) // End forEach
          // console.log(blockedDays, days)
          /**
           * Generate the base creneauxDispo array out of the opened days defined in Storage Model
           */
          let weekDays = new Map();
          weekDays.set(min.getDay(), min.format());
          vm.serverData.days.forEach(day => {
            if (day > min.getDay()) {
              weekDays.set(day, min.addDays(day - min.getDay()).format());
            }
          })
          /**
           * Remove google calendars blocked days before looping over each day
           */
          blockedDays.forEach(blockedDay => weekDays.delete(blockedDay))
          /**
           * Generate all the default available slots
           */
          weekDays.forEach(day => {
            let string = ``;
            vm.creneauxSemaine().forEach(creneau => {
              string = `${day} ${creneau}`;
              vm.creneauxDispo.push(string)
            })
          })
          /**
           * Remove the taken slots
           */
          // console.log("Créneaux dispo", vm.creneauxDispo)
          // console.log("Créneaux pris", creneauxPris)
          vm.creneauxDispo = vm.creneauxDispo.filter(creneau => !creneauxPris.has(creneau));
        })
        .finally(() => this.loading = false)
    },
    save() {
      this.saving = true
      $api.post(`g2r/v1/calendar/event/`, {
        ...this.$data,
        magasin_id: g2rObj.postId,
        overrideCalendarId: this.calendarId
      })
        .then(response => response.data)
        .then(data => {
          if (!data) {
            alert(`Un problème a empêché l'enregistrement du rendez-vous ! Nous vous invitons à recharger la page puis re-essayer, ou à nous contacter par téléphone si le problème persiste.`)
          } else {
            this.saved = true
          }
        })
        .catch(error => console.error(error))
        .finally(() => {
          this.saving = false
          this.$store.dispatch('closeModal')
        })
    },
  },
  beforeMount() {
    this.postId = parseInt(g2rObj.postId)
    // Get server data
    this.loadingServerData = true
    $api.get(`g2r/v1/storage/`, {params: {magasin_id: g2rObj.postId}})
      .then(response => response.data)
      .then(data => {
        // console.log(data)
        this.serverData = data
        this.calCanMount = true
      }).finally(() => {
      this.loadingServerData = false
    })
    // populate user data
    if (g2rObj.hasOwnProperty('userId')) {
      const userData = JSON.parse(document.querySelector(`[name="userData"]`).value);
      // console.log(userData)
      Object.keys(userData).forEach(key => this[key] = userData[key])
    }
  },
  beforeDestroy() {
    if (this.intervalId > 0) {
      clearInterval(this.intervalId);
    }
    this.$store.dispatch('closeModal')
  },
}
</script>

<style scoped lang="scss">

[v-cloak] {
  display: none;
}

.retrait {
  margin-top: 2rem;
  font-size: 1.4rem;

  p.delai {
    font-style: italic;
    font-weight: bold;
    color: var(--red);
    margin-bottom: 1rem;
    text-align: right;
  }

  form {
    //align-self: center;
    margin-bottom: 3rem;

    fieldset {
      padding: 2rem;

      legend {
        text-align: right;
      }

      .grid__label-input {
        display: grid;
        grid-template-columns: 1fr 3fr;
        grid-column-gap: 2%;
        margin-bottom: 1rem;

        label {
          align-self: center;
          justify-self: end;
          line-height: 1;
        }

        input, select {
          margin-bottom: 0;
          padding: 1rem 15px;
          height: 40px;
          font-size: 1.4rem;
        }
      }

      .retrait__form--helper {
        text-align: right;
      }
    }
  }

  #atelier-inside {
    height: 30px;
    padding: 0;
    width: auto;
    margin-left: .5rem;
    margin-bottom: 5px;
  }

  ::v-deep {
    .vuecal__menu {
      background-color: var(--dark-blue);
    }

    .vuecal__title {
      label {
        font-size: 15px;
        cursor: pointer;
        display: inline-flex;
        align-items: center;
        accent-color: var(--dark-blue);

        [type="radio"] {
          margin: auto 5px;
        }

        svg {
          margin-right: .5rem;
        }

        &:last-child {
          margin-left: 1rem;
        }
      }
    }
  }

}

@media screen and (min-width: 768px) {
  .retrait {
    display: grid;
    grid-template-columns: 1fr 1.8fr;
    grid-column-gap: 2%;
  }

  form {
    margin-bottom: 0;
  }
}

</style>

<style lang="scss">

.retrait {
  .vuecal {
    height: 500px;
  }

  .vuecal__weekdays-headings {
    font-size: 1.2rem;
  }

  .vuecal__cell.disabled {
    background: repeating-linear-gradient(45deg,
      #fdfdfd,
      #fdfdfd 10px,
      #f7f7f7 10px,
      #f7f7f7 20px);

    .vuecal__no-event {
      opacity: 0;
    }
  }

  .vuecal__no-event {
    line-height: 1;
    font-size: 1rem;
    color: var(--dark-blue);
    font-style: italic;
  }

  .vuecal__event-title, .vuecal__event-time {
    font-size: 1rem;
  }

  .vuecal__event {
    cursor: pointer;
    padding: 5px;
    color: var(--dark-blue);
  }

  .vuecal:not(.vuecal--dragging-event) .vuecal__event:hover {
    background-color: rgba(0, 165, 188, .1);
  }

  .vuecal__time-column .vuecal__time-cell {
    .label {
      color: var(--dark-blue);
      font-size: 1.2rem;
    }
  }

  .vuecal__header button {
    &:focus, &:hover {
      background-color: rgba(0, 165, 188, .33);
    }
  }

  .modal-content {
    h4 {
      margin-top: 0;
    }

    footer {
      text-align: right;

      button {
        padding: 1rem 2rem;
        font-size: 1.3rem;

        &:first-child {
          margin-right: 1rem;
        }
      }
    }

    .animation-ctn {
      margin-top: 1rem;
    }
  }
}

// transitions
.fade-enter-active, .fade-leave-active {
  transition: opacity .1s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

</style>
